module.exports = __webpack_public_path__ + "img/1497465930.03e1dbee.jpg";